import { render, staticRenderFns } from "./block-advantages-bottom.vue?vue&type=template&id=d9938350&scoped=true"
import script from "./block-advantages-bottom.vue?vue&type=script&lang=js"
export * from "./block-advantages-bottom.vue?vue&type=script&lang=js"
import style0 from "./block-advantages-bottom.vue?vue&type=style&index=0&id=d9938350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9938350",
  null
  
)

export default component.exports